import React from 'react';
import { FiImage } from 'react-icons/fi';

const IconPreview = React.memo(function IconPreview({
                                                        file,
                                                        className = 'w-full h-full object-contain rounded',
                                                    }) {
    const [url, setUrl] = React.useState(null);

    React.useEffect(() => {
        if (!file) {
            setUrl(null);
            return;
        }

        // If it's a File or Blob, create an object URL
        if (file instanceof File || file instanceof Blob) {
            const objUrl = URL.createObjectURL(file);
            setUrl(objUrl);
            return () => URL.revokeObjectURL(objUrl);
        }

        // Otherwise, treat it as a URL or base64 string
        setUrl(file);
    }, [file]);

    return url ? (
        <img
            src={url}
            alt="icon"
            className={className}
        />
    ) : (
        <FiImage className={className.replace('object-contain', '') + ' text-gray-500'} />
    );
});

export default IconPreview;
